import React from "react"
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography
} from "@mui/material"

type RadiosShowcaseProps = {
    size: "small" | "medium"
}

const RadiosShowcase: React.FC<RadiosShowcaseProps> = ({size}: RadiosShowcaseProps) => {
  const [radioValue, setRadioValue] = React.useState("")

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Typography className="text-xl font-bold">Radios Showcase</Typography>
      <FormControl fullWidth component="fieldset">
        <RadioGroup
          value={radioValue}
          onChange={(e) => setRadioValue((e.target as HTMLInputElement).value)}
        >
          <FormControlLabel
            value="option1"
            control={<Radio size={size} />}
            label="Opción 1"
          />
          <FormControlLabel
            value="option2"
            control={<Radio size={size} />}
            label="Opción 2"
          />
          <FormControlLabel
            value="option3"
            control={<Radio size={size} />}
            label="Opción 3"
          />
        </RadioGroup>
        </FormControl>   
    </Box>
  )
}

export default RadiosShowcase
